import { CheckOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Flex, Form, FormInstance, Spin } from 'antd';
import React, { ReactNode, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { BUFFER_INPUT_DELAY } from '../const';
import useObserverComponent from '../hooks/useObserverComponent';
import { RootState } from '../store';
import { ItemType } from '../types';

interface IFieldNameInHeader<T> {
    form: FormInstance<T>;
    field: ReactNode;
    fieldAvatar?: ReactNode;
    valueNameField?: string;
    isShowEditButton?: boolean;
}

const FieldNameInHeader = <T,>({
    form,
    field,
    fieldAvatar,
    valueNameField,
    isShowEditButton,
}: IFieldNameInHeader<T>) => {
    const { isVisible, ref } = useObserverComponent();
    const currentGantItem = useSelector<RootState, ItemType | null>((state) => state.gantItems.currentGantItem);
    const [isEdit, setIsEdit] = useState(false);
    const [spinner, setSpinner] = useState(false);

    useEffect(() => {
        if (!isVisible) {
            setIsEdit(false);
        }
    }, [isVisible]);

    useEffect(() => {
        setIsEdit(false);
    }, [currentGantItem]);

    const onCLickEdit = () => {
        setIsEdit(true);
    };

    const onCLickConfirm = () => {
        setSpinner(true);
        setTimeout(() => {
            setSpinner(false);
            setIsEdit(false);
        }, BUFFER_INPUT_DELAY);
    };

    return (
        <Flex ref={ref} gap={10} justify={'space-between'} align={'center'} style={{ minHeight: 24 }}>
            {isEdit ? (
                <Flex flex={1}>
                    <div style={{ flex: 13 }}>
                        <Spin spinning={spinner}>
                            <Form name="scheduleItemFromLabel" layout={'vertical'} form={form} autoComplete="off">
                                {field}
                            </Form>
                        </Spin>
                    </div>
                    <div style={{ flex: 1 }}>
                        <Button
                            shape={'circle'}
                            icon={<CheckOutlined />}
                            type={'text'}
                            color="default"
                            onClick={onCLickConfirm}
                            style={{ marginLeft: 8 }}
                        />
                    </div>
                </Flex>
            ) : (
                <Flex gap={10} align={'center'}>
                    <div style={{ flex: 10 }}>{`${valueNameField || ''}`}</div>
                    {isShowEditButton && (
                        <div style={{ flex: 1 }}>
                            <Button
                                shape={'circle'}
                                icon={<EditOutlined />}
                                type={'text'}
                                color="default"
                                onClick={onCLickEdit}
                            />
                        </div>
                    )}
                </Flex>
            )}
            <Flex>{fieldAvatar}</Flex>
        </Flex>
    );
};

export default FieldNameInHeader;
